/* Packages */
import React from 'react';
import { createRoot } from 'react-dom/client';

const configurator = Array.from(document.querySelectorAll('[data-vehicle-configurator]'));

if (configurator.length) {
    import(/* webpackChunkName: "Configurator" */ './VehicleConfigurator').then(({ default: VehicleConfigurator }) => {
        configurator.forEach((node) => {
            const root = createRoot(node);
            root.render(<VehicleConfigurator {...(JSON.parse(node.dataset.vehicleConfigurator || '{}'))} />);
        });
    });
}
